import styled from "styled-components";

export const ContenedorHome = styled.div`
  width: 100%;
  height: auto;
  span {
    color: #f15a59;
  }
`;
